export default __webpack_public_path__ + "static/media/history.bccb05a8.svg";